<ng-container *ngIf="layoutService.showBaseLayout; else contentOnly">
  <div class="app-shell">
    <header class="app-topbar">
      <div class="app-topbar-left">
        <img
          *ngIf="logoUrl()"
          class="app-topbar-logo"
          [src]="logoUrl()"
          alt=""
        />
        <span class="app-topbar-divider"></span>
        <span class="app-topbar-title" [title]="pageTitle()">{{
          pageTitle()
        }}</span>
      </div>
      <div class="app-topbar-right">
        <ng-content select="[shellActions]"></ng-content>
        <button
          type="button"
          class="account-button"
          (click)="accountPanel.toggle($event)"
        >
          <div class="account-avatar account-avatar-sm">{{ initials() }}</div>
          <div
            class="account-button-text"
            *ngIf="identityService.identity as identity"
          >
            <div class="account-button-name">
              {{ identity.givenName }} {{ identity.surname }}
            </div>
            <div class="account-button-org">
              {{ identity.organisationName }}
            </div>
          </div>
        </button>
        <sh-account-panel
          #accountPanel
          [profileRoute]="profileRoute()"
          [loginRoute]="loginRoute()"
          [showThemeToggle]="showThemeToggle()"
        ></sh-account-panel>
      </div>
    </header>

    <div class="app-shell-body">
      <sh-app-rail [menu]="menu()"></sh-app-rail>
      <main class="app-shell-content">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </main>
    </div>
  </div>
</ng-container>

<ng-template #contentOnly>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<!-- The page is projected exactly once, here, and rendered by whichever
     branch above is active: Angular only projects into one <ng-content>
     per selector, so two plain default slots would leave one of them empty. -->
<ng-template #content><ng-content></ng-content></ng-template>
